// material-ui
import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';

// loader style
// Confined to its own layout slot (in-flow, not fixed to the viewport) so it only
// covers the content area of the route being loaded, leaving the header/sidebar
// nav interactive while a module's chunk is loading.
const LoaderWrapper = styled('div')(() => ({
  width: '100%',
  minHeight: 'calc(100vh - 110px)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

// ==============================|| Loader ||============================== //

const Loader = () => (
  <LoaderWrapper>
    {/* <LinearProgress color="primary" sx={{ height: 2 }} /> */}
    <CircularProgress size={40} color="primary" />
  </LoaderWrapper>
);

export default Loader;
